export const filterMenuByPermissions = (items, canAccessModule) => {
    return items
      .map((item) => {
        if (item.type === "item") {
          return canAccessModule(item.moduleKey) ? item : null;
        }
  
        // For "collapse"
        if (item.type === "collapse") {
          const filteredChildren = filterMenuByPermissions(item.children, canAccessModule);
  
          if (filteredChildren.length === 0) return null;
  
          return { ...item, children: filteredChildren };
        }
  
        // For "group"
        if (item.type === "group") {
          const filteredChildren = filterMenuByPermissions(item.children, canAccessModule);
  
          if (filteredChildren.length === 0) return null;
  
          return { ...item, children: filteredChildren };
        }
  
        return null;
      })
      .filter(Boolean);
  };
  